export const SET_LOADING = 'spotify/SET_LOADING';
export const SET_ERROR = 'spotify/SET_ERROR';
export const SET_READY = 'spotify/SET_READY';
export const SET_TEXT = 'spotify/SET_TEXT';
export const SET_PLAYBACK_STATE = 'spotify/SET_PLAYBACK_STATE';
export const SET_MUTE = 'spotify/SET_MUTE';